import { LoadSpinner } from '@calizahq/react-components-v2'
import { AgentDashboardPotentialBooking } from '@sales-app/types/AgentDashboard'
import React, { FC, useMemo } from 'react'

import { Table } from '@/components'

import { AgentDashboardPotentialBookingColumns } from './PotentialBookings.data'

type AgentDashboardPotentialBookingProps = {
  isLoading: boolean
  potentialBookings?: AgentDashboardPotentialBooking[]
}

export const PotentialBookings: FC<AgentDashboardPotentialBookingProps> = ({ isLoading, potentialBookings = [] }) => {
  const columns = useMemo(() => {
    return AgentDashboardPotentialBookingColumns
  }, [])

  return (
    <div className="flex w-full flex-col mt-4 py-4">
      <div className="mb-2 flex w-full items-center justify-between md:mb-4 md:flex-row">
        <h2 className=" text-header-lg leading-120">
          {isLoading ? '' : `${potentialBookings.length} `}Potential Bookings
        </h2>
      </div>

      {isLoading ? (
        <div className="flex h-20 w-full items-center justify-center">
          <LoadSpinner className="icon-secondary" isCurrentColor={true} size={2} />
        </div>
      ) : (
        <>
          <Table className={''} columns={columns as any} data={potentialBookings} />
        </>
      )}
    </div>
  )
}
